<template>
  <div class="reward-list-page">
    <header class="reward-list-header">
      <button class="reward-list-back" type="button" :aria-label="$t('Back')" @click="back">
        <img src="../../static/images/back.png" alt="">
      </button>
      <div>
        <h1>{{ $t('RewardClaimTitle') }}</h1>
      </div>
    </header>

    <main class="reward-list-content">
      <div v-if="loading" class="reward-list-loading">{{ $t('LiveQuizLoading') }}</div>
      <div v-else-if="rewards.length === 0" class="reward-list-empty">
        <img src="../../static/images/home/prize.png" alt="">
        <p>{{ $t('RewardNoPending') }}</p>
      </div>
      <section v-else class="reward-list-cards" :aria-label="$t('RewardClaimTitle')">
        <button
          v-for="reward in rewards"
          :key="reward.id"
          class="reward-list-card"
          type="button"
          :disabled="claimingId === reward.id"
          @click="claimReward(reward)"
        >
          <img class="reward-list-card-gift" src="../../static/images/home/prize_act.png" alt="">
          <span class="reward-list-card-copy">
            <strong>{{ reward.name }}</strong>
            <small>{{ $t('RewardExpiresAt') }} {{ formatExpireTime(reward.expire_time) }}</small>
          </span>
          <span class="reward-list-card-action">{{ claimingId === reward.id ? $t('RewardClaiming') : $t('RewardClaimNow') }}</span>
        </button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rewards: [],
      loading: true,
      claimingId: null,
      claimResetTimer: null
    }
  },
  created () {
    this.getRewards()
  },
  beforeDestroy () {
    clearTimeout(this.claimResetTimer)
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getRewards () {
      this.loading = true
      this.$api.get('/api/reward/index', null, response => {
        this.loading = false
        this.$parent.returnCode(response, () => {
          this.rewards = (response.data && response.data.list) || []
        })
      })
    },
    claimReward (reward) {
      if (this.claimingId !== null) return
      this.claimingId = reward.id
      clearTimeout(this.claimResetTimer)
      this.claimResetTimer = setTimeout(() => {
        this.claimingId = null
      }, 12000)
      this.$api.post('/api/reward/claim', {reward_id: reward.id}, response => {
        clearTimeout(this.claimResetTimer)
        this.claimingId = null
        this.$parent.returnCode(response, () => {
          this.$utils.alertText(response.msg, 80, 1800)
          this.getRewards()
        })
      })
    },
    formatExpireTime (value) {
      return value ? String(value).slice(0, 10) : ''
    }
  }
}
</script>

<style scoped>
.reward-list-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 38px 28px 80px;
  color: #fff;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') center / cover no-repeat;
  font-family: Arial, Atom-sans, sans-serif;
}

.reward-list-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  text-align: center;
}

.reward-list-header h1 {
  margin: 0;
  font-family: "Arial Black", Atom-sans, sans-serif;
  font-style: italic;
  line-height: .95;
}

.reward-list-header h1 {
  color: #fff;
  font-size: clamp(34px, 8vw, 62px);
  text-transform: uppercase;
}

.reward-list-back {
  position: absolute;
  top: 50%;
  left: 0;
  width: 62px;
  height: 62px;
  padding: 0;
  border: 0;
  transform: translateY(-50%);
  background: transparent;
  box-shadow: none;
}

.reward-list-back img { width: 100%; }
.reward-list-content { max-width: 700px; margin: 34px auto 0; }

.reward-list-loading,
.reward-list-empty {
  min-height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 28px;
}

.reward-list-empty img { width: 150px; margin-bottom: 18px; }
.reward-list-empty p { max-width: 430px; margin: 0; line-height: 1.35; }
.reward-list-cards { display: grid; gap: 22px; }

.reward-list-card {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  align-items: center;
  gap: 10px 20px;
  width: 100%;
  min-height: 170px;
  padding: 18px 24px;
  border: 2px solid rgba(255, 189, 66, .9);
  border-radius: 30px;
  color: #fff;
  text-align: left;
  background: linear-gradient(145deg, rgba(104, 4, 70, .96), rgba(19, 2, 48, .96));
  box-shadow: inset 0 0 28px rgba(255, 34, 142, .23), 0 10px 24px rgba(0, 0, 0, .28);
}

.reward-list-card:disabled { opacity: .72; }
.reward-list-card-gift { width: 124px; grid-row: span 2; }
.reward-list-card-copy { min-width: 0; }

.reward-list-card-copy strong,
.reward-list-card-copy small {
  display: block;
  overflow-wrap: anywhere;
}

.reward-list-card-copy strong {
  color: #ffef73;
  font-family: "Arial Black", Atom-sans, sans-serif;
  font-size: clamp(24px, 5.1vw, 37px);
  line-height: 1.08;
}

.reward-list-card-copy small {
  margin-top: 9px;
  color: rgba(255,255,255,.82);
  font-size: clamp(16px, 3.5vw, 24px);
  line-height: 1.2;
}

.reward-list-card-action {
  justify-self: start;
  padding: 10px 22px;
  border-radius: 999px;
  color: #fff;
  font-family: "Arial Black", Atom-sans, sans-serif;
  font-size: clamp(17px, 3.7vw, 26px);
  line-height: 1;
  white-space: nowrap;
  background: linear-gradient(180deg, #ff5c9a, #f31679 60%, #fc7316);
  text-shadow: 0 2px 0 #671136;
}
</style>



// WEBPACK FOOTER //
// src/page/rewardList.vue